import React from "react";
import { FontAwesomeIcon, FontAwesomeIconProps } from "@fortawesome/react-fontawesome";
import { faCog } from "@fortawesome/pro-solid-svg-icons";
import { DefaultIconStyle } from "./styles";

export const IconCog: React.FC<Partial<FontAwesomeIconProps>> = props => {
  return <FontAwesomeIcon style={DefaultIconStyle} {...props} icon={faCog} />;
};
